import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
} from "../../components/Component";
import { getToken } from "../../helper/auth";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import * as moment from "moment";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from 'react-router-dom';
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import { GET } from "../../helper/api";

import ReactToPrint from "react-to-print";

const PieceWageCategoryManager = () => {
  const printRef = useRef();

  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);
  const [timeNow, setTimeNow] = useState();

  const [rangeDate, setRangeDate] = useState({
    startDate: searchParams.get('startDate') ? moment(searchParams.get('startDate')).startOf('days').toDate() : moment().startOf('months').toDate(),
    endDate: searchParams.get('endDate') ? moment(searchParams.get('endDate')).endOf('days').toDate() : moment().endOf('days').toDate(),
  });

  const onRangeChange = (dates) => {
    const [startDate, endDate] = dates;
    setRangeDate({
      startDate: startDate ? moment(startDate)?.startOf('days').toDate() : startDate,
      endDate: endDate ? moment(endDate)?.endOf('days').toDate() : endDate
    });
    if (startDate && endDate) {
      setTimeNow(moment().valueOf());
    }
  };

  const colTable = useMemo(() => {
    const tempColTable = [
      {
        Header: "Tên",
        accessor: (item) => item.name,
      },
    ];
    if (data.length > 0) {
      const { users } = data[0];
      Object.entries(users).forEach(([userId, { name }]) => {
        tempColTable.push({
          Header: name,
          className: 'text-right',
          accessor: (item) => <NumericFormat
            displayType={"text"}
            value={item.users[userId].amount || 0}
            thousandsGroupStyle="thousand"
            thousandSeparator=","
            decimalScale={2}
          />,
        })
      })
    }
    return tempColTable
  }, [data])


  // Changing state value when searching name
  useEffect(() => {
    const newParams = new URLSearchParams({
      ...rangeDate,
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })


    setLoading(true);

    let params = {
      startDate: moment(rangeDate.startDate).format("YYYY-MM-DD"),
      endDate: moment(rangeDate.endDate).format("YYYY-MM-DD"),
    };

    GET(`employee/summary-piece-wage-group-by-categories`, params, true)
      .then(({ data: { data, summary, total } }) => {
        setData([...data]);
        setSummary({
          ...summary,
          total
        })
      })
      .finally(() => {
        setLoading(false);
      });
  }, [timeNow]);

  const exportExcel = () => {
    const params = new URLSearchParams({
      startDate: moment(rangeDate.startDate).format("YYYY-MM-DD"),
      endDate: moment(rangeDate.end).format("YYYY-MM-DD"),
      token: getToken(),
    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/employee/report-summary-piece-wage-group-by-categories-excel?${params.toString()}`;
    window.open(url, '_blank')
  };


  return (
    <React.Fragment>
      <Head title="Quản lý tổng hợp xuống hàng"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Tổng hợp xuống hàng</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <DatePicker
                          selected={rangeDate.startDate}
                          startDate={rangeDate.startDate}
                          onChange={onRangeChange}
                          endDate={rangeDate.endDate}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>
                    <li>
                      <div className="d-inline-block mr-3">
                        <ReactToPrint
                          trigger={() => <Button className={'btn-secondary'}>In</Button>}
                          content={() => printRef.current}
                          pageStyle={``}
                        />
                        <Button className={'btn-secondary ml-3'} onClick={exportExcel}>
                          Xuất excel
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3" ref={printRef}>
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                    customRow={() => data?.length > 0 ? (<>
                      <tr>
                        <td>Tổng cộng(đ)</td>
                        {Object.keys(data[0].users).map(userId => <td className="text-right"><NumericFormat
                          displayType={"text"}
                          value={summary?.[userId] || 0}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        /></td>)}
                      </tr>
                      <tr>
                        <td>Tổng tiền(đ)</td>
                        <td colSpan={100} className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summary?.total || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </td>
                      </tr>
                    </>) : <></>}
                  />
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default PieceWageCategoryManager;
